import { loginsignup_submit } from "./loginsignup_page";
import { checkEmailValid } from "./util/general_util";
$("form[reauthForm]").on("submit", function(event) {
    event.preventDefault();
    let form:JQuery<HTMLElement> = $(this);
    let emailInput:JQuery<HTMLElement> = form.find("input[name='email']")
    let errEl:JQuery<HTMLElement> = form.find("[errEl]");
    let submitBtn:JQuery<HTMLElement> = form.find("button[type='submit']");
    let email:string = (emailInput.val() as string).trim();
    if (!checkEmailValid(email)) {
      errEl.find("[errMsg]").html("Email is invalid");
      errEl.removeClass("d-none");
      return;
    };
    form.find("input[name='grecaptchaResponse']").val(window.recaptchaResponse);
    errEl.addClass("d-none");
    submitBtn.attr("disabled", "disabled"); // Disable the login button
    loginsignup_submit(form).then(response => {
      submitBtn.removeAttr("disabled"); // Enable the login button
      if (response.redirectUrl) {
        window.location.href = response.redirectUrl;
      } else if (response.isRedirect === false) {
        $("body").html(response.html)
      };
    }).catch(e => {
      submitBtn.removeAttr("disabled"); // Enable the login button
      errEl.find("[errMsg]").html(e.responseText);
      errEl.removeClass("d-none");
    });
});